<template>
  <div class="desp">
    <div class="desp-header">Linked Orders:</div>
    <!-- 订单列表 -->
    <div class="desp-items-group" v-for="item in detail.orderList" :key="`orderList-${item.id}`">
      <div class="desp-items-group-title">Order Information</div>
      <div class="desp-items-wrapper">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Applicant Name</div>
              <div class="desp-item-content">{{ item.applicantName }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Transaction No.</div>
              <div class="blue crp desp-item-content" @click="toLinkOrderDetail(item.id)">{{ item.businessNo }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Order No.</div>
              <div class="blue crp desp-item-content" @click="invoiceLink(item.orderNo)">{{ item.orderNo }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Oder Status</div>
              <div class="desp-item-content">{{ orderStatusFormat(item.status) }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Create Time</div>
              <div class="desp-item-content">{{ item.createTime }}</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="desp-item">
              <div class="desp-item-label">Description</div>
              <div class="desp-item-content">{{ item.description }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import Package from "@/components/ServiceGather/Package";
import DiyPackage from "@/components/ServiceGather/DiyPackage";
import QuotationSubtotal from "@/components/ServiceGather/QuotationSubtotal";
import QuotationVSingle from "@/components/ServiceGather/QuotationVSingle";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [formatterMixin],
  components: {
    Package,
    DiyPackage,
    QuotationSubtotal,
    QuotationVSingle,
  },
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    // 发票跳转
    invoiceLink(invoiceNumber) {
      const newPage = `${process.env.VUE_APP_URL_INVOICE}/invoice?invoiceNo=${invoiceNumber}`;
      window.open(newPage, "_blank");
    },
    // 订单详情跳转
    toLinkOrderDetail(id) {
      this.$router.push(`/finance/order/${id}`);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variables.scss";

.jump-icon {
  vertical-align: middle;
  font-size: 20px;
  margin-right: 6px;
  margin-top: -4px;
}

.to-link {
  cursor: pointer;
  color: #{$--color-primary};
}
</style>
